<template>
  <div>

    <modal-edicao-imagem ref="modalEdicaoImagem"
                        :imagemEditar="imagemEditar"
                        @imagemEditada="buscarImagens" />

    <modal-associa-imagem ref="modalTopicoImagem"
                        :cursos="cursos"
                        :modulos="modulos"
                        :licoes="licoes"
                        :imagens-selecionadas="imagensSelecionadas"
                        @imagensAssociadas="buscarImagens" />

      <modal-cadastro-imagem ref="modalCadastroImagem"
                            />

      <div class="tab-pane fade show active" id="pills-imagens" role="tabpanel" aria-labelledby="pills-imagens-tab">
      <div>
        <b-link v-b-toggle="'collapse-adicionar-imagens'" @click="modalAdicionarImagem()" class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-plus"></i> Adicionar Imagem</b-link>&#32;
        <b-link v-b-toggle="'collapse-filter-imagens'" class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>&#32;
        <div class="dropdown btn-acoes mb-2 mb-md-0 d-inline-block">
          <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Ações
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item" href="javascript:void(0)" @click="modalAssociarImagem()">Adicionar à lição</a>
          </div>
        </div>
      </div>
    </div>

    <b-collapse id="collapse-filter-imagens" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarImagens">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Url do imagem</label>
                    <input type="text" class="form-control" placeholder="Url da imagem" v-model="filtro.url" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Tipo</label>
                    <select class="form-control" v-model="filtro.tipo_imagem_id">
                      <option v-if="tiposImagem.length == 0" value="">Carregando...</option>
                      <option v-if="tiposImagem.length > 0" value="">Selecione</option>
                      <option v-for="tipos in tiposImagem" :key="tipos.id" :value="tipos.id">{{ tipos.descricao }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-8">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.createdDate" /> Filtrar por data de criação</label>
                    <date-range-picker
                      v-if="filtro.createdDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.createdDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-2 position-relative" v-if="imagens.length">
      <table class="table" ref="resultadoTabelaImagens">
        <thead>
          <tr>
            <th></th>
            <th>#</th>
            <th>Url</th>
            <th>Tipo de Imagem</th>
            <th>Data de Cadastro</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="imagem in imagens" v-bind:key="'imagem'+imagem.id">
            <td><input type="checkbox" @click="alteraSelecionada(imagem)"  v-model="imagensSelecionadas" :value="imagem"/></td>
            <td>{{ imagem.id }}</td>
            <td>{{ imagem.url }}</td>
            <td>{{ imagem.tipo_imagem_id && imagem.tipo_imagem.descricao || ' - '  }}</td>
            <td>{{ imagem.created_at | formatDatetime }}</td>
            <td>
              <img :src="obterUrlS3(imagem)" v-if="!imagem.mostrarAviso" @error="imagemErro(imagem)">
              <i class="fas fa-2x fa-exclamation-circle" v-else v-b-tooltip.hover title="Imagem não encontrada"></i>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0)" v-b-tooltip.hover title="Editar" @click="modalEdicaoImagem(imagem)" v-if="verificaEdicao(imagem)"><i class="fas fa-edit"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import ModalEdicaoImagem from '@/modules/Conteudo/components/ModalEdicaoImagem'
import ModalAssociaImagem from '@/modules/Conteudo/components/ModalAssociaImagem'
import modalCadastroImagem from '@/modules/Conteudo/components/modalCadastroImagem'
import InfiniteLoading from 'vue-infinite-loading'
import ImagemAPI from '@/api/imagem-api'
import CursoAPI from '@/api/curso-api'
import ModuloAPI from '@/api/modulo-api'
import LicaoAPI from '@/api/licao-api'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import DateUtils from '@/core/util/date-utils'
import moment from 'moment'
import Swal from 'sweetalert2'
import EmpresaUtils from '@/core/util/empresa-utils'

export default {
  name: 'ListaImagens',
  props: {
    perfil: Object
  },
  components: {
    DateRangePicker,
    InfiniteLoading,
    ModalEdicaoImagem,
    ModalAssociaImagem,
    modalCadastroImagem
  },
  data () {
    return {
      pagina: 1,
      quantidade: 0,
      cursos: [],
      modulos: [],
      licoes: [],
      imagens: [],
      tiposImagem: [],
      infiniteId: new Date(),
      scrolled: false,
      filtro: {
        id: '',
        url: '',
        tipo_imagem_id: '',
        createdDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(new Date())
        }
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      },
      imagemEditar: {},
      imagensSelecionadas: []
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },

  mounted () {
    ImagemAPI.listarTipos().then(data => {
      this.tiposImagem = data.filter(data => (
        data.id === 1 || data.id === 4
      ))
    })
    CursoAPI.listar().then(data => {
      this.cursos = data
    })
    ModuloAPI.listar().then(data => {
      this.modulos = data
    })
    LicaoAPI.listar().then(data => {
      this.licoes = data
    })
  },

  methods: {
    verificaEdicao (imagem) {
      let empresaId = EmpresaUtils.getEmpresa().id
      if (empresaId === imagem.empresa_criadora_id) {
        return true
      }
      if (empresaId === 1) {
        return true
      }
      return false
    },

    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    handleKeyDown: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = true
      }
    },

    handleKeyUp: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = false
      }
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    buscarImagens: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.imagens = []
      this.imagensSelecionadas = []
    },

    alteraSelecionada: function (imagem) {
      if (this.shiftPressed && this.ultimoSelecionado) {
        let maiorQueUltimo = (imagem.id > this.ultimoSelecionado.id)
        let novosSelecionados = []
        novosSelecionados = this.imagens.filter(item => {
          if (maiorQueUltimo) {
            return (item.id <= imagem.id) && (item.id >= this.ultimoSelecionado.id)
          } else {
            return (item.id <= this.ultimoSelecionado.id) && (item.id >= imagem.id)
          }
        })
        novosSelecionados.map(imagem => {
          !this.imagensSelecionadas.includes(imagem) && this.imagensSelecionadas.push(imagem)
        })
      }
      this.ultimoSelecionado = imagem
    },

    infiniteHandler: function ($state) {
      ImagemAPI.listar(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.imagens.push(...data.data.map(item => {
            if (item.tipo_imagem_id === 3) {
              Object.assign(item, {
                tipo_imagem_id: 1
              })
              Object.assign(item.tipo_imagem, {
                id: 1,
                descricao: 'Curso'
              })
            }
            Object.assign(item, {
              mostrarAviso: false
            })
            return item
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    },

    modalEdicaoImagem: function (imagem) {
      this.imagemEditar = imagem

      this.$nextTick(() => {
        this.$refs.modalEdicaoImagem.show()
      })
    },

    obterUrlS3: function (imagem) {
      return this.$refs.modalEdicaoImagem.obterUrlS3(imagem)
    },

    imagemErro: function (imagem) {
      imagem.mostrarAviso = true
    },

    modalAssociarImagem: function () {
      if (this.imagensSelecionadas && this.imagensSelecionadas.length >= 1) {
        this.imagemEditar = null

        this.imagensSelecionadas = this.imagensSelecionadas.sort(function (a, b) {
          return new Date(a.id) - new Date(b.id)
        })

        this.$nextTick(() => {
          this.$refs.modalTopicoImagem.show()
        })
      } else {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Selecione uma ou mais imagens para associar a uma lição'
        })
      }
    },

    modalAdicionarImagem: function () {
      this.$nextTick(() => {
        this.$refs.modalCadastroImagem.show()
      })
    }
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
